export default __webpack_public_path__ + "static/media/lock.23e2b7df.png";